import { Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';

interface BoxEntryCardProps {
  boxCount: number;
  onOpen: () => void;
}

const CardRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2.5),
  padding: theme.spacing(3),
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}));

/**
 * Card d'ingresso alla sezione "Box auto" (mostrata solo se l'utente ha ≥1 box).
 * Rimanda alla lista configurazioni box.
 */
export function BoxEntryCard({ boxCount, onOpen }: BoxEntryCardProps) {
  return (
    <CardRoot>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 56,
          height: 56,
          flexShrink: 0,
          borderRadius: '50%',
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
        }}
      >
        <DirectionsCarIcon />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="h3" component="div" sx={{ lineHeight: 1.2 }}>
          Box auto
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {boxCount === 1 ? 'Hai 1 box da personalizzare' : `Hai ${boxCount} box da personalizzare`}
          {' '}(basculante, ricarica auto, unioni).
        </Typography>
      </Box>
      <Button variant="contained" color="primary" onClick={onOpen} sx={{ flexShrink: 0 }}>
        Configura i tuoi box
      </Button>
    </CardRoot>
  );
}
